exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media print {\n  body {\n    width: 1070px;\n    margin: 0 auto !important; }\n  .route-sheet .route-number {\n    width: 30px; }\n  .route-sheet .route-coins {\n    width: 150px; }\n  .route-sheet .route-dates {\n    width: 50px; }\n  .route-sheet .route-total {\n    width: 50px; }\n  .page-break {\n    display: block;\n    page-break-after: always; } }\n\n@page print-landscape {\n  size: landscape;\n  margin: 1cm; }\n\n.print-landscape {\n  page: print-landscape; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/app.print.scss
// module id = 938
// module chunks = 1